const TRANSLATIONS = {
    // menu
    MENU_HOME: {
        ko: "홈",
        en: "Home",
    },
    MENU_PROFILE: {
        ko: "프로필",
        en: "Profile",
    },
    MENU_SEARCH: {
        ko: "검색",
        en: "Search",
    },
    MENU_NOTI: {
        ko: "알림",
        en: "Notifications",
    },
    MENU_LOGOUT: {
        ko: "로그아웃",
        en: "Logout",
    },
    MENU_LOGIN: {
        ko: "로그인",
        en: "Login",
    },
    MENU_SIGNUP: {
        ko: "회원가입",
        en: "Signup",
    },
    // button
    BUTTON_FOLLOWING: {
        ko: "팔로잉",
        en: "Following",
    },
    BUTTON_FOLLOW: {
        ko: "팔로우",
        en: "Follow",
    },
    BUTTON_EDIT: {
        ko: "수정",
        en: "Edit",
    },
    BUTTON_DELETE: {
        ko: "삭제",
        en: "Delete",
    },
    BUTTON_EDIT_PROFILE: {
        ko: "프로필 수정",
        en: "Edit Profile",
    },
    BUTTON_COMMENT: {
        ko: "댓글 입력",
        en: "Comment",
    },
    // post
    NO_POSTS: {
        ko: "게시글이 없습니다",
        en: "No Posts",
    },
    POST_PLACEHOLDER: {
        ko: "내용을 입력해주세요.",
        en: "What is happening?",
    },
    POST_HASHTAG: {
        ko: "해시태그 + 스페이스바 입력",
        en: "Enter hashtags with spacebar",
    },
    POST_CHANGE_IMAGE: {
        ko: "이미지 변경",
        en: "Change Image",
    },
    NAME_PLACEHOLDER: {
        ko: "이름",
        en: "Name",
    },
    // tabs
    TAB_FOLLOWING: {
        ko: "팔로잉",
        en: "Following",
    },
    TAB_ALL: {
        ko: "전체",
        en: "For You",
    },
    TAB_LIKES: {
        ko: "좋아요",
        en: "Likes",
    },
    TAB_MY: {
        ko: "내가쓴 글",
        en: "My Tweets",
    },
    // search
    SEARCH_HASHTAGS: {
        ko: "해시태그 검색",
        en: "Search Hashtags",
    },
    // profile
    PROFILE_NAME: {
        ko: "사용자님",
        en: "User",
    },
    // notification
    NO_NOTIFICATIONS: {
        ko: "알림이 없습니다",
        en: "No notifications",
    },
    // signin, signup
    FORM_EMAIL: {
        ko: "이메일",
        en: "Email",
    },
    FORM_PASSWORD: {
        ko: "비밀번호",
        en: "Password",
    },
    FORM_PASSWORD_CHECK: {
        ko: "비밀번호 확인",
        en: "Confirm Password",
    },
    NO_ACCOUNT: {
        ko: "계정이 없으신가요?",
        en: "No Account?",
    },
    YES_ACCOUNT: {
        ko: "계정이 있으신가요?",
        en: "Already have account?",
    },
    LOGIN_WITH_GOOGLE: {
        ko: "Google 로그인",
        en: "Continue with Google",
    },
    LOGIN_WITH_GITHUB: {
        ko: "Github 로그인",
        en: "Continue with Github",
    },
    SIGNUP_GOOGLE: {
        ko: "Google 회원가입",
        en: "Continue with Google",
    },
    SIGNUP_GITHUB: {
        ko: "Github 회원가입",
        en: "Continue with Github",
    },
    SIGNUP_LINK: {
        ko: "회원가입하기",
        en: "Sign up",
    },
    SIGNIN_LINK: {
        ko: "로그인하기",
        en: "Login",
    },
};

export default TRANSLATIONS;
